import { useLDClient } from 'launchdarkly-react-client-sdk'

import { isLaunchdarklyEnabled } from '@/shared/libs/launchdarkly/utils'

export const useLaunchdarklyReady = () => {
  const ldClient = useLDClient()

  if (!isLaunchdarklyEnabled()) {
    return true
  }

  return Boolean(ldClient)
}
